import NotFound from "./Components/NotFound";

import Dashboard from "./Pages/Dashboard/Dashboard";

import AddDeveloper from "./Pages/Developers/Add";

import Edit from "./Pages/Developers/Edit";

import { DevelopersTable } from "./Pages/Developers/Index";

import AddProject from "./Pages/projects/Add";

import { ProjectsTable } from "./Pages/projects/Index";

import EditProject from "./Pages/projects/Edit";

import { CustomersTable } from "./Pages/Customers/Index";

import AddCustomer from "./Pages/Customers/Add";

import EditCustomers from "./Pages/Customers/Edit";

import TaskForm from "./Pages/Tasks/Add";

import { TaskTable } from "./Pages/Tasks/Index";

import { DesignationTable } from "./Pages/Designations/Index";

import AddDesignation from "./Pages/Designations/Add";

import EditDesignation from "./Pages/Designations/Edit";

import EditTask from "./Pages/Tasks/Edit";

import { RoleTable } from "./Pages/Roles/Index";

import AddRole from "./Pages/Roles/Add";

import EditRole from "./Pages/Roles/Edit";

import AttandanceTable from "./Pages/Attendance/index";

import EditAttendance from "./Pages/Attendance/Edit";

import { Profile } from "./Pages/Profile/Profile";

import { LeavePage } from "./Pages/Leave/index";

import ApplyLeave from "./Pages/Leave/applyleave";

import MissPunchTable from "./Pages/MissPunch";

import Overtimetable from "./Pages/Overtime/index";

import OvertimeAdd from "./Pages/Overtime/Add";

import OvertimeEdit from "./Pages/Overtime/Edit";

import { TasksTable } from "./Pages/Task/Index";

import TasksForm from "./Pages/Task/Add";

import EditTasks from "./Pages/Task/Edit";

import HolidaysTable from "./Pages/Holidays/Index";

import Editholidays from "./Pages/Holidays/Edit";

import JobApplicationPage from "./Pages/JobApplication/Index";

import Resignation from "./Pages/Resignation/index";

import CampassoffPage from "./Pages/Campassoff/Index";

import ContactsPage from "./Pages/Contacts/Index";

import CompaniesPage from "./Pages/Companies/Index";

// import DealsPage from "./Pages/Deals/Index";

// import LeadsPage from "./Pages/Leads/Index";

import Setting from "./Pages/Settings/Setting";

// import DealPage from "./Pages/Deals/Index";

import LeadsAnalytics from "./Pages/Analytics/LeadsAnalytics";

import SourcePage from "./Pages/Source/Index";

import CalendarPage from "./Pages/Calendar/Index";

import JobApplicationAnalytics from "./Pages/Analytics/JobApplicationAnalytics";

import TagPage from "./Pages/Tags/Index";

import ExpenseTypePage from "./Pages/ExpenseType/index";

import RawDataPage from "./Pages/RawData/Index";

import ReportPage from "./Pages/Report/Index";

// import DummyTaskPage from "./Pages/Tasks/DummyTaskPage";

import LogViewer from "./Pages/log/log";

import path from "path";

import { Component } from "lucide-react";

import ExpensePage from "./Pages/Expense/Expense";

import { ComponentType } from "react";

import ReceiptsPage from "./Pages/Receipts/Receipts";

import InvoicePage from "./Pages/Invoice/Index";

import AddInvoicePage from "./Pages/Invoice/AddInvoicePage";

import EditInvoicePage from "./Pages/Invoice/EditInvoicePage";

import CopyInvoicePage from "./Pages/Invoice/CopyInvoicePage";

import InvoicePreview from "./Pages/Invoice/InvoicePreview";

import ShiftPage from "./Pages/Shift/index";

import AmcMaintenancePage from "./Pages/AMC-Maintenance/index";

import Chatbot from "./Pages/Chatbot/Chatbot";

import EmailTemplates from "./Pages/Master/EmailTemplates";

import NotificationConfiguration from "./Pages/NotificationConfiguration/index";

// import SocialMedia from "./Pages/SocialMedia/SocialMedia";

const AdminRoutes = [
  {
    path: "/dashboard",

    name: "Customers",

    component: Dashboard,
  },

  {
    path: "/invoice/add",

    name: "Add Invoice",

    component: AddInvoicePage,
  },

  {
    path: "/invoice/edit/:id",

    name: "Edit Invoice",

    component: EditInvoicePage,
  },

  {
    path: "/invoice/copy/:id",

    name: "Copy Invoice",

    component: CopyInvoicePage,
  },

  {
    path: "/invoice-preview",

    name: "Invoice Preview",

    component: InvoicePreview,
  },

  {
    path: "/profile",

    name: "profile",

    component: Profile,
  },

  {
    path: "/developers",

    name: "Developers",

    component: DevelopersTable,
  },

  // {

  //   path: "/backend/developers/add",

  //   component: AddDeveloper,

  // },

  // {

  //   path: "/developers/:id/edit",

  //   component: Edit,

  // },

  {
    path: "/projects",

    name: "Projects",

    component: ProjectsTable,
  },

  // {

  //   path: "/backend/projects/add",

  //   component: AddProject,

  // },

  // {

  //   path: "/projects/:id/edit",

  //   component: EditProject,

  // },

  {
    path: "/customers",

    name: "Customers",

    component: CustomersTable,
  },

  // {

  //   path: "/backend/customers/add",

  //   component: AddCustomer,

  // },

  {
    path: "/tasks",

    name: "Tasks",

    component: TaskTable,
  },

  // {

  //   path: "/backend/tasks/add",

  //   name: "Tasks",

  //   component: TaskForm,

  // },

  // {

  //   path: "/tasks/:id/edit",

  //   name: "Tasks",

  //   component: EditTask,

  // },

  {
    path: "/task",

    name: "Task",

    component: TasksTable,
  },

  // {

  //   path: "/backend/task/add",

  //   name: "Task",

  //   component: TasksForm,

  // },

  // {

  //   path: "/task/:id/edit",

  //   name: "Tasks",

  //   component: EditTasks,

  // },

  {
    path: "/designations",

    name: "Designation",

    component: DesignationTable,
  },

  // {

  //   path: "/backend/designations/add",

  //   name: "Designation",

  //   component: AddDesignation,

  // },

  // {

  //   path: "/designations/edit/:id",

  //   name: "Designation",

  //   component: EditDesignation,

  // },

  {
    path: "/roles",

    name: "Role",

    component: RoleTable,
  },

  // {

  //   path: "/backend/roles/add",

  //   name: "Role",

  //   component: AddRole,

  // },

  // {

  //   path: "/roles/edit/:id",

  //   name: "Designation",

  //   component: EditRole,

  // },

  {
    path: "/attendance",

    name: "Attendance",

    component: AttandanceTable,
  },

  {
    path: "/email-templates",

    name: "Email Templates",

    component: EmailTemplates,
  },

  {
    path: "/notifications",

    name: "Notification Configuration",

    component: NotificationConfiguration,
  },

  // {

  //   path: "/attendance/:id/edit",

  //   name: "Attendance",

  //   component: EditAttendance

  // },

  { path: "*", name: "Not Found", component: NotFound },

  {
    path: "/leave",

    name: "leave",

    component: LeavePage,
  },

  // {

  //   path: "/leave/apply-leave",

  //   name: "applyleave",

  //   component: ApplyLeave,

  // },

  {
    path: "/misspunch",

    name: "Misspunch",

    component: MissPunchTable,
  },

  {
    path: "/overtime",

    name: "Overtime",

    component: Overtimetable,
  },

  // {

  //   path: "/overtime/add-overtime",

  //   name: "Overtimeadd",

  //   component: OvertimeAdd,

  // },

  // {

  //   path: "/overtime/Edit-overtime/:id",

  //   name: "Overtime",

  //   component: OvertimeEdit,

  // },

  {
    path: "/holidays",

    name: "Holidays",

    component: HolidaysTable,
  },

  // {

  //   path: "/holidays/edit/:id",

  //   name: "Holidays",

  //   component: Editholidays,

  // },

  {
    path: "/jobapplications",

    name: "Job Application",

    component: JobApplicationPage,
  },

  {
    path: "/resignation",

    name: "Resignation",

    component: Resignation,
  },

  {
    path: "/campus-off",

    name: "Campus Off",

    component: CampassoffPage,
  },

  {
    path: "/contacts",

    name: "Contacts",

    component: ContactsPage,
  },

  {
    path: "/companies",

    name: "companies",

    component: CompaniesPage,
  },

  // {

  //   path: "/deals",

  //   name: "deals",

  //   component: DealPage,

  // },

  // {

  //   path: "/leads",

  //   name: "leads",

  //   component: LeadsPage,

  // },

  {
    path: "/settings",

    name: "Settings",

    component: Setting,
  },

  {
    path: "/leadsAnalytics",

    name: "Analytics",

    component: LeadsAnalytics,
  },

  {
    path: "/jobApplicationAnalytics",

    name: "Analytics",

    component: JobApplicationAnalytics,
  },

  {
    path: "/source",

    name: "Source",

    component: SourcePage,
  },

  {
    path: "/tags",

    name: "Tags",

    component: TagPage,
  },

  {
    path: "/shift",

    name: "Shift",

    component: ShiftPage,
  },

  {
    path: "/calendar",

    name: "Calendar",

    component: CalendarPage,
  },

  {
    path: "/expense",

    name: "Expense",

    component: ExpensePage,
  },

  {
    path: "/invoice",

    name: "Invoice",

    component: InvoicePage,
  },

  {
    path: "/amc-maintenance",

    name: "AMC Maintenance",

    component: AmcMaintenancePage,
  },

  {
    path: "/receipts",

    name: "Receipts",

    component: ReceiptsPage,
  },

  {
    path: "/report",

    name: "Report",

    component: ReportPage,
  },

  {
    path: "/rawdata",

    name: "RawData",

    component: RawDataPage,
  },

  {
    path: "/logs",

    name: "Logs",

    component: LogViewer,
  },

  {
    path: "/chat",

    name: "Chats",

    component: Chatbot,

    // role: "admin",
  },

  {
    path: "/chat/:id",

    name: "Chat Detail",

    component: Chatbot,

    // role: "admin",
  },

  // {

  //   path:"/dummy-tasks",

  //   name: "Dummy Tasks",

  //   component: DummyTaskPage,

  // }

  // {
  //   path: "/social-media",

  //   name: "Social Media",

  //   component: SocialMedia,
  // },
];

export { AdminRoutes };
